export default __webpack_public_path__ + "img/jira-logo.c329a4.svg";